<template>
  <v-app>
    <v-app-bar app color="blue-grey darken-2" dark>
      <v-app-bar-nav-icon @click.stop="nav_drawer = !nav_drawer" />
      <h1>EVE Ships & Fits</h1>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-navigation-drawer v-model="nav_drawer" temporary app>
      <v-list nav>
        <v-list-item to="/">
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item to="/ships">
          <v-list-item-avatar>
            <v-img src="./assets/ships.png"></v-img>
          </v-list-item-avatar>
          <v-list-item-title>Ships</v-list-item-title>
        </v-list-item>
        <v-list-item to="/fittings">
          <v-list-item-avatar>
            <v-img src="./assets/fitting.png"></v-img>
          </v-list-item-avatar>
          <v-list-item-title>Fittings</v-list-item-title>
        </v-list-item>
        <v-list-item to="/character">
          <v-list-item-avatar>
            <v-img src="./assets/charactersheet.png"></v-img>
          </v-list-item-avatar>
          <v-list-item-title>Character</v-list-item-title>
        </v-list-item>
        <v-list-item :href="login_url">
          <v-list-item-title>Login</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-content class="mb-5">
      <v-card v-if="loading" class="mx-auto text-center py-3" max-width="400">
        <v-progress-circular indeterminate size="32"></v-progress-circular>
        Loading initial content via ESI
      </v-card>
      <router-view v-else />
    </v-content>

    <v-footer>
      <v-btn text @click="clearCache">Clear cache</v-btn>
      <v-spacer></v-spacer>
      <div>&copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "App",
  data() {
    return {
      nav_drawer: false
    };
  },
  computed: {
    ...mapState({
      loading: "initial_load",
      loggedIn: "character_id",
      login_url: "login_url"
    })
  },
  methods: {
    clearCache() {
      this.$store.dispatch("clearCache");
    }
  },
  created() {
    this.$store.dispatch("loadInitialContent");
  }
};
</script>

<style lang="scss">
.box {
  height: 1rem;
  width: 1rem;
  background-color: #fff;
  display: inline-block;
  margin-left: 0.25rem;
  vertical-align: middle;
}
.v-application a.home_link {
  text-decoration: none;
  color: #fff;
}
</style>
